import styled from 'styled-components'

import Button from 'components/Global/Button'
import Icon from 'components/Global/Icon/styled'

export const PageTitleStyled = styled.div`
  display: flex;
  flex: 1;
  padding: 1rem 0.5rem;
  align-items: center;

  h1 {
    font-size: ${({ theme }) => theme.text.xl.size}rem;
    font-weight: ${({ theme }) => theme.text.xl.weight};
    margin-bottom: 0;
    color: ${({ theme }) => theme.color.strongText};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ${Icon} {
    width: auto;
    min-width: 1.2rem;
    height: 1.2rem;
    margin-right: 0.8rem;
    color: ${({ theme }) => theme.color.strongText};
    display: flex;

    img,
    svg {
      position: relative;
      left: 0;
      top: 0;
      height: 100%;
      width: auto;
    }
  }
`

export const FavouriteButton = styled(Button)`
  margin-left: 0.8rem;

  ${Icon} {
    color: ${({ theme, isActive }) =>
      isActive ? theme.color.highlight || theme.color.main : theme.color.softText};
  }
`
